<template>
  <!-- Otonamiと共通のCalendar  -->
  <MoleculesWabunkaCalendar
    data-testid="experience-calendar"
    lang="en"
    :class="['my-2 w-full ', props.noBorder ? 'border-0' : '']"
    :day="calendarDisplayMonth"
    :is-error="props.isError"
    @on-change="props.onChangeMonth"
  >
    <template #content="{ day: calendarDay, isCurrentMonth }">
      <button
        v-if="isCurrentMonth"
        class="w-full"
        type="button"
        :disabled="getIsDisabled(calendarDay)"
        @click="() => props.onClickDate(calendarDay, props.calendarEvents[formatHyphenatedDate(calendarDay)])"
      >
        <div v-if="props.isLoading" class="px-4 py-4">
          <MoleculesWabunkaSkeltonText class="m-auto h-6 w-6 py-2" data-testid="calendar-day-skelton" />
        </div>
        <MoleculesDate
          v-else
          data-testid="calendar-day"
          :availability-status="getAvailabilityStatusBasedOnDate(calendarDay, calendarEvents)"
          :day="calendarDay"
          :disabled="getIsDisabled(calendarDay)"
          :is-selected="props.selectedDate?.isSame(calendarDay, 'date') ?? false"
        />
      </button>
    </template>
  </MoleculesWabunkaCalendar>
</template>

<script setup lang="ts">
import MoleculesDate from '@/components/molecules/wabunka/Date/Date.vue';
import { getIsDisabledDate } from '@/models/view/experience/experienceCalendar';
import { getAvailabilityStatusBasedOnDate } from '@/models/wabunka/view/experience/wabunkaExperienceCalendar';
import { formatHyphenatedDate } from '@/utils/date';
import type { WabunkaExperienceEventDictViewModel, WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

import type dayjs from 'dayjs';

interface Props {
  // デフォルトのカレンダーの日付（モックしやすいように外部から注入する形にしている）
  selectedDate?: dayjs.Dayjs;
  // カレンダーの表示月を外部から指定する（selectedDate とは独立）
  displayMonth?: dayjs.Dayjs;
  calendarEvents: WabunkaExperienceEventDictViewModel;
  isError?: boolean;
  onChangeMonth: (startDateStr: string, endDateStr: string) => void;
  onClickDate: (selectedDate: dayjs.Dayjs, selectedDateEvents: WabunkaExperienceEventViewModel[] | undefined) => void;
  noBorder?: boolean;
  isLoading?: boolean;
}

const props = defineProps<Props>();

// カレンダーが表示すべき月を決定する
// displayMonth が指定されていればそれを優先、なければ selectedDate にフォールバック
const calendarDisplayMonth = computed(() => props.displayMonth ?? props.selectedDate);

const getIsDisabled = (calendarDay: dayjs.Dayjs) => {
  return getIsDisabledDate(calendarDay) || getAvailabilityStatusBasedOnDate(calendarDay, props.calendarEvents) === 'UNAVAILABLE';
};
</script>
